
export let environment = {
  production: false,
  baseWebApiUrl: "/",
  enableCventmail: false,
  backgroundCheck: true,
  helpUrl: "https://support.cvent.com/Transient/s/knowledgebase",
  googleMapUrl: "",
  GDPRMsgStart: new Date("2018-05-23T00:00:00-05:00"),
  GDPRMsgEnd: new Date("2018-05-30T00:00:00-05:00"),
  PortalLoginPage : ""
};
window['CKEDITOR_BASEPATH'] = '/Scripts/ckeditor/';

